// extracted by mini-css-extract-plugin
export var caption = "PersonalData-module--caption--4cf60";
export var companyLink = "PersonalData-module--companyLink--c7f77";
export var fadeInAnimation = "PersonalData-module--fadeInAnimation--960e2";
export var linkedinIcon = "PersonalData-module--linkedinIcon--67778";
export var name = "PersonalData-module--name--5b636";
export var photo = "PersonalData-module--photo--d77e6";
export var position = "PersonalData-module--position--88e99";
export var wrapper = "PersonalData-module--wrapper--fc49c";